import { InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import FormFactory from "../../../../components/FormFactory";
import withRouter from "../../../../withRouter";
import GroupCollectinoPresenter from "./GroupCollectinoPresenter";

class ViewGroupCollectionFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      deletedObjects: [],
      addedObjects: [],
    };
    this.presenter = new GroupCollectinoPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return "group_schedule";
  }

  deletedObject(value) {
    console.log("Delete: ", value);
    if (!this.state.deletedObjects.some((obj) => obj.id === value.id)) {
      this.setState((prevState) => ({
        deletedObjects: [...prevState.deletedObjects, value],
      }));
    }
  }

  addedObject(value) {
    if (!this.state.addedObjects.some((obj) => obj.id === value.id)) {
      this.setState((prevState) => ({
        addedObjects: [...prevState.addedObjects, value],
      }));
    }
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        object={object}
                        disabled={true}
                        onChange={this.onChange.bind(this)}
                        deletedObject={this.deletedObject.bind(this)}
                        addedObject={this.addedObject.bind(this)}
                      />
                    )}
                  </div>
                  <div className="mt-4">
                    {/* <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ViewGroupCollectionFormPage);
